import { apiPost } from '../../api'

export const save_application = data => {
  return apiPost({
    endpoint: 'application/save_application',
    data: data
  })
}
